import { get } from 'lodash';

const spinnerSelectors = {
  isLoading: ({ spinner }) => (get(spinner, 'loading', false)),
  loadingMessage: ({ spinner }) => (get(spinner, 'message', null)),
};

export default spinnerSelectors;
